import type { Editor } from '@tiptap/core';

export interface IRichTextSelection {
	from: number;
	to: number;
}

export const getRichTextSelectionText = (editor: Editor, selection: IRichTextSelection): string =>
	editor.state.doc.textBetween(selection.from, selection.to, ' ');

export const applyRichTextLink = (
	editor: Editor,
	rawUrl: string,
	selection: IRichTextSelection = editor.state.selection,
	rawText = ''
): boolean => {
	const trimmedUrl = rawUrl.trim();
	if (!trimmedUrl) return false;

	const href = /^(https?:|mailto:)/i.test(trimmedUrl) ? trimmedUrl : `https://${trimmedUrl}`;
	const text = rawText.trim();
	const chain = editor.chain().focus().setTextSelection(selection);
	// Unchanged text keeps setLink so formatting inside the selection (bold, italics) survives.
	if (selection.from !== selection.to && (!text || text === getRichTextSelectionText(editor, selection).trim())) {
		return chain.setLink({ href }).run();
	}

	return chain
		.insertContentAt(selection, { type: 'text', text: text || href, marks: [{ type: 'link', attrs: { href } }] })
		.run();
};
